export const routes = [
  {
    path: "/",
    name: "inicio",
    meta: {
      title: "Inicio",
    },
    component: () => import("../views/Inicio.vue"),
  },
  {
    path: "/painel",
    name: "painel",
    meta: {
      title: "Painel",
    },
    component: () => import("../views/Painel.vue"),
  },
  {
    path: "/registro",
    name: "registro",
    meta: {
      title: "Registro",
    },
    component: () => import("../views/Registro.vue"),
  },
  {
    path: "/boasvindas",
    name: "boasvindas",
    meta: {
      title: "Boas Vindas",
    },
    component: () => import("../views/BoasVindas.vue"),
  },
  {
    path: "/altura",
    name: "altura",
    meta: {
      title: "Altura",
    },
    component: () => import("../views/Altura.vue"),
  },
  {
    path: "/peso",
    name: "peso",
    meta: {
      title: "Peso",
    },
    component: () => import("../views/Peso.vue"),
  },
  {
    path: "/atividade-fisica",
    name: "atividade-fisica",
    meta: {
      title: "Peso",
    },
    component: () => import("../views/SecaoAtividadeFisicaMobilidade.vue"),
  },
  {
    path: "/doenca",
    name: "doenca",
    meta: {
      title: "Doença",
    },
    component: () => import("../views/Doenca.vue"),
  },
  {
    path: "/problema-coracao",
    name: "problema-coracao",
    meta: {
      title: "Doença",
    },
    component: () => import("../views/ProblemaCoracao.vue"),
  },
  {
    path: "/itens-apoio",
    name: "itens-apoio",
    meta: {
      title: "Itens Apoio",
    },
    component: () => import("../views/PesquisaItensApoio.vue"),
  },
  {
    path: "/secao-doenca-cronica",
    name: "secao-doenca-cronica",
    meta: {
      title: "Doença Crônica",
    },
    component: () => import("../views/SecaoSaudeDoencaCronica.vue"),
  },
  {
    path: "/pesquisa-condicoes-saude",
    name: "pesquisa-condicoes-saude",
    meta: {
      title: "Condições de Saúde",
    },
    component: () => import("../views/PesquisaCondicoesSaude.vue"),
  },
  {
    path: "/fumante",
    name: "fumante",
    meta: {
      title: "Fumante",
    },
    component: () => import("../views/Fumante.vue"),
  },
  {
    path: "/bebida",
    name: "bebida",
    meta: {
      title: "Bebida",
    },
    component: () => import("../views/Bebida.vue"),
  },
  {
    path: "/alimentacao-nutricao",
    name: "alimentacao-nutricao",
    meta: {
      title: "Alimentação e Nutrição",
    },
    component: () => import("../views/SecaoAlimentacaoNutricao.vue"),
  },
  {
    path: "/alimentacao-diaria",
    name: "alimentacao-diaria",
    meta: {
      title: "Alimentação Diária",
    },
    component: () => import("../views/PesquisaAlimentacaoDiaria.vue"),
  },
  {
    path: "/alimentacao-horarios-regulares",
    name: "alimentacao-horarios-regulares",
    meta: {
      title: "Alimentação Horários Regulares",
    },
    component: () => import("../views/PesquisaAlimentacaoHorarios.vue"),
  },
  {
    path: "/alimentacao-quantidade-refeicoes",
    name: "alimentacao-quantidade-refeicoes",
    meta: {
      title: "Alimentação Quantidade Refeições",
    },
    component: () => import("../views/PesquisaQuantidadeRefeicoes.vue"),
  },
  {
    path: "/alimentacao-ultraprocessados",
    name: "alimentacao-ultraprocessados",
    meta: {
      title: "Alimentação Ultrprocessados",
    },
    component: () => import("../views/PesquisaUltraprocessados.vue"),
  },
  {
    path: "/bem-estar-sono",
    name: "bem-estar-sono",
    meta: {
      title: "Bem Estar Sono",
    },
    component: () => import("../views/SecaoBemEstarSono.vue"),
  },
  {
    path: "/avaliacao-sono",
    name: "avaliacao-sono",
    meta: {
      title: "Avaliação Sono",
    },
    component: () => import("../views/PesquisaAvaliacaoSono.vue"),
  },
  {
    path: "/horas-sono",
    name: "horas-sono",
    meta: {
      title: "Horas Sono",
    },
    component: () => import("../views/PesquisaHorasSono.vue"),
  },
  {
    path: "/secao-inclusao-digital",
    name: "secao-inclusao-digital",
    meta: {
      title: "Horas Sono",
    },
    component: () => import("../views/SecaoInclusaoDigitalSaude.vue"),
  },
  {
    path: "/whatsapp-redes-sociais",
    name: "whatsapp-redes-sociais",
    meta: {
      title: "Whatsapp Redes Sociais",
    },
    component: () => import("../views/PesquisaWhatsappRedesSociais.vue"),
  },
  {
    path: "/secao-expectativas-sugestoes",
    name: "secao-expectativas-sugestoes",
    meta: {
      title: "Expectativas Sugestões",
    },
    component: () => import("../views/SecaoExpectativasSugestoes.vue"),
  },
  {
    path: "/motivou-participar-projeto",
    name: "motivou-participar-projeto",
    meta: {
      title: "Motivou Participar Projeto",
    },
    component: () => import("../views/PesquisaMotivacaoProjeto.vue"),
  },
  {
    path: "/atividade-projeto-ansioso-participar",
    name: "atividade-projeto-ansioso-participar",
    meta: {
      title: "Atividade Projeto Ansioso Participar",
    },
    component: () => import("../views/PesquisaAnsiosoParticipar.vue"),
  },
  {
    path: "/alergia",
    name: "alergia",
    meta: {
      title: "Alergia",
    },
    component: () => import("../views/Alergia.vue"),
  },
  {
    path: "/acucar",
    name: "acucar",
    meta: {
      title: "Açucar",
    },
    component: () => import("../views/Acucar.vue"),
  },
  {
    path: "/agua",
    name: "agua",
    meta: {
      title: "Água",
    },
    component: () => import("../views/Agua.vue"),
  },
  {
    path: "/main",
    name: "main",
    meta: {
      title: "Principal",
    },
    component: () => import("../views/Main.vue"),
  },
  {
    path: "/sidebar",
    name: "sidebar",
    meta: {
      title: "Menu Lateral",
    },
    component: () => import("../views/SideBar.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "Login",
    },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/confirmacao",
    name: "confirmacao",
    meta: {
      title: "Confirmacao",
    },
    component: () => import("../views/ConfirmacaoEvento.vue"),
  },
  {
    path: "/pesquisa",
    name: "pesquisa",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/SecaoNossoProjeto.vue"),
  },
  {
    path: "/pesquisa-recomendacao",
    name: "pesquisa-recomendacao",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaRecomendacao.vue"),
  },
  {
    path: "/qualidade-vida",
    name: "qualidade-vida",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaQualidadeVida.vue"),
  },
  {
    path: "/fisica-mental",
    name: "fisica-mental",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaFisicaMental.vue"),
  },
  {
    path: "/estrutura",
    name: "estrutura",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaEstrutura.vue"),
  },
  {
    path: "/necessidades",
    name: "necessidades",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaNecessidades.vue"),
  },
  {
    path: "/melhoria-saude",
    name: "melhoria-saude",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/SecaoMelhoriaFisicaMental.vue"),
  },
  {
    path: "/condicoes-saude",
    name: "condicoes-saude",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaCondicoes.vue"),
  },
  {
    path: "/mobilidade",
    name: "mobilidade",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaMobilidade.vue"),
  },
  {
    path: "/dores",
    name: "dores",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaDores.vue"),
  },
  {
    path: "/estilo-vida",
    name: "estilo-vida",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaEstiloVida.vue"),
  },
  {
    path: "/humor",
    name: "humor",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaHumor.vue"),
  },

  {
    path: "/isolamento",
    name: "isolamento",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/SecaoIsolamento.vue"),
  },
  {
    path: "/solidao",
    name: "solidao",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaSolidao.vue"),
  },
  {
    path: "/chat",
    name: "chat",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaChat.vue"),
  },
  {
    path: "/amizade",
    name: "amizade",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaAmizade.vue"),
  },
  {
    path: "/evento-social",
    name: "evento-social",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaEventoSocial.vue"),
  },
  {
    path: "/valorizado-sociedade",
    name: "valorizado-sociedade",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaValorizadoSociedade.vue"),
  },
  {
    path: "/inclusao-digital",
    name: "inclusao-digital",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/SecaoInclusaoDigital.vue"),
  },
  {
    path: "/pesquisa-tecnologia",
    name: "pesquisa-tecnologia",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaTecnologia.vue"),
  },
  {
    path: "/acesso",
    name: "acesso",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaAcesso.vue"),
  },
  {
    path: "/confiante-celular",
    name: "confiante-celular",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaConfianteCelular.vue"),
  },
  {
    path: "/capacitacoes-digitais",
    name: "capacitacoes-digitais",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaCapacitacaoDigital.vue"),
  },
  {
    path: "/acesso-inclusao-digital",
    name: "acesso-inclusao-digital",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaAcessoInclusaoDigital.vue"),
  },
  {
    path: "/seguranca-alimentar-nutricional",
    name: "seguranca-alimentar-nutricional",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/SecaoAlimentarNutricional.vue"),
  },
  {
    path: "/kit-nutricional",
    name: "kit-nutricional",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaKitNutricional.vue"),
  },
  {
    path: "/alimentos-adequados",
    name: "alimentos-adequados",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaAlimentosAdequados.vue"),
  },
  {
    path: "/escolhas-alimentares",
    name: "escolhas-alimentares",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaEscolhasAlimentares.vue"),
  },
  {
    path: "/educacao-nutricional",
    name: "educacao-nutricional",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/PesquisaEducacaoNutricional.vue"),
  },
  {
    path: "/feedback-melhorias",
    name: "feedback-melhorias",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/SecaoFeedBackMelhorias.vue"),
  },
  {
    path: "/atividade-mais-gostou",
    name: "atividade-mais-gostou",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/FeedBackAtividadeMaisGostou.vue"),
  },
  {
    path: "/melhorias-sugeridas",
    name: "melhorias-sugeridas",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/FeedBackMelhoriasSugeridas.vue"),
  },
  {
    path: "/voluntarios-atendem-necessidades",
    name: "voluntarios-atendem-necessidades",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/FeedBackVoluntariosNecessidades.vue"),
  },
  {
    path: "/inclusao-futura",
    name: "inclusao-futura",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/FeedBackInclusaoFutura.vue"),
  },
  {
    path: "/comentario-depoimento",
    name: "comentario-depoimento",
    meta: {
      title: "Pesquisa",
    },
    component: () => import("../views/FeedBackComentarioDepoimento.vue"),
  },
  {
    path: "/videos",
    name: "videos",
    meta: {
      title: "Videos",
    },
    component: () => import("../views/Videos.vue"),
  },
];
